import {
  useSuspenseQuery,
  type UseSuspenseQueryOptions,
} from "@tanstack/react-query";
import { useExonnApi } from "src/exonn-api/exonn-api.tsx";
import type {
  CountryResource,
  CurrencyResource,
  LanguageResource,
} from "@exonn/js-sdk";

export type GlobalSettings = {
  default_country: CountryResource;
  default_language: LanguageResource;
  default_currency: CurrencyResource;
  prices_defined_in_net: boolean;
  return_withdrawal_days: number;
  return_full_warranty_days: number;
  return_warranty_days: number;
  return_dealer_full_warranty_days: number;
  return_dealer_excluded_full_days: number;
  return_dealer_excluded_warranty_days: number;
  return_full_warranty_from: string;
  return_dealer_rules_valid_until: string;
  return_preauthorized_lifetime_days: number;
  return_collect_threshold: string;
  /** Порог «дешевле — не забираем» и история возвратов клиента. */
  return_collect_threshold_enabled: boolean;
  return_history_window_days: number;
  return_history_alert_count: number;
  return_external_warehouse_enabled: boolean;
  return_refund_delivery_only_within_withdrawal: boolean;
  prices_show_in_net: boolean;
  delivery_methods_that_require_tax_calculation: string[];
  countries_vat_status: string[];
  marketing_sms_texts_amount: number;
  marketing_allow_downloading_customers_list: boolean;
  accounting_postings_blocked_date: string;
  groupoffice_url: string;
  event_tickets_enabled: boolean;
};

type ResponseData = {
  data: GlobalSettings;
};

export const useGlobalSettings = (
  options?: Omit<
    UseSuspenseQueryOptions<
      ResponseData["data"],
      any,
      ResponseData["data"],
      any
    >,
    "queryFn" | "queryKey"
  >,
) => {
  const api = useExonnApi();
  return useSuspenseQuery({
    queryKey: ["globalSettings"],
    queryFn: async ({ signal }) => {
      return (
        await api.client.get<ResponseData>("/system/global-settings/all", {
          signal,
        })
      ).data.data;
    },
    ...options,
  });
};
